import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  height: 60vh;
`;

export default Container;
